<template>
  <Tooltip v-if="dotData" :show="show" :position="position">
    <table>
      <tbody>
        <tr>
          <td>{{ $t("trends.count") }}</td>
          <td>{{ dotData.count }}</td>
        </tr>
        <tr>
          <td>{{ $t("trends.percentageYear") }}</td>
          <td>{{ formatPercentage(dotData.percentageYear) }}</td>
        </tr>
        <tr>
          <td>{{ $t("trends.percentageTotal") }}</td>
          <td>{{ formatPercentage(dotData.percentageTotal) }}</td>
        </tr>
        <tr>
          <td>{{ $t("data.year") }}</td>
          <td>{{ dotData.year }}</td>
        </tr>
        <tr>
          <td class="text-capitalize">
            {{ $tc("pluralization.word", dotData.keys.length) }}
          </td>
          <td>
            <div v-for="t in dotData.keys" :key="t.key">
              <div class="d-flex align-center">
                <div
                  class="mr-2"
                  :style="`width: 16px; height: 16px; background: ${t.color};`"
                ></div>
                <div>{{ t.value }} ({{ $t(`data.${t.type}`) }})</div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </Tooltip>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";
import { format } from "d3-format";

export default {
  components: {
    Tooltip
  },
  props: {
    dotData: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    position: {
      type: Array,
      default: () => [9999, 9999]
    }
  },
  created() {
    this.formatPercentage = format(".2%");
  }
};
</script>

<style scoped>
.tooltip-container {
  pointer-events: none;
}

td {
  vertical-align: top;
  padding: 0 16px;
}
</style>
